<template>
    <v-container class="type-navigation">
        <div class="type-title">
            <div class="content-style"></div>
            <div class="title-content">企业团体保障</div>
        </div>
        <v-card flat>
            <div class="type-card">
                <div class="type-tag parent-col">
                    <div class="parent-col-tab-container">
                        <v-tabs class="parent-col-tabs" v-model="_category1">
                            <v-tab class="parent-col-tab"
                                   v-for="(category,key) in categorySub"
                                   :key="key"
                                   :href="`#${category.code}`"
                                   @click="clickCategory1(category.code)"
                            >{{ category.value }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <div class="type-tag child-col">
<!--                    <p>险种<i></i></p>-->
                    <div class="content-box">
                        <ul>
                            <li
                               v-for="(item,key) in categoryChild"
                               :key="key"
                               :class="{active: _category2===item.code}"
                               @click="clickCategory2(item.code)"
                            >{{ item.value }}</li>
                        </ul>
                    </div>
                </div>
                <div class="type-tag online-offline">
<!--                    <p>产品类型<i></i></p>-->
                    <div class="content-box">
                        <ul>
                            <li
                               v-for="(item,key) in onlineStatusList"
                               :key="key"
                               :class="{active: _onlineStatus===item.code}"
                               @click="clickOnlineStatus(item.code)"
                            >{{ item.value }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: "Navigation",
        props: {
            category1:{
                type: String,
                default: "staff_welfare"
            },
            category2:{
                type: String,
                default: ""
            },
            onlineStatus:{
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                categorySub: [],
                categoryChild: [],
                onlineStatusList: [
                    {
                        code: 0,
                        value: "全部"
                    },
                    {
                        code: 1,
                        value: "互联网产品"
                    },
                    {
                        code: 2,
                        value: "线下产品"
                    }
                ]
            }
        },
        mounted() {
            //获取分类
            this.$store.dispatch("getDictsCategorys").then(()=>{
                this.categorySub = this.$store.getters.getCategoryTop("product_category");
                this.getChildList(this.category1)
            });
            let form = {
                code: this.category1
            };
            this.$emit("getList", form);
        },
        computed:{
            _category1:{
                get(){
                    return this.category1
                },
                set(value){
                    this.$emit("update:category1", value);
                }
            },
            _category2:{
                get(){
                    return this.category2
                },
                set(value){
                    this.$emit("update:category2", value);
                }
            },
            _onlineStatus:{
                get(){
                    return this.onlineStatus
                },
                set(value){
                    this.$emit("update:onlineStatus", value);
                }
            },
        },
        methods:{
            clickCategory1(value){
                this._category2 = ""
                this.getChildList(value);
                let form = {
                    code: value
                };
                if (this._onlineStatus > 0){
                    form['onlineStatus'] = this._onlineStatus;
                }
                this.$emit("getList", form);
            },
            clickCategory2(value){
                this._category2 = value;
                let form = {
                    code: value
                };
                if (this._onlineStatus > 0){
                    form['onlineStatus'] = this._onlineStatus;
                }
                this.$emit("getList", form);
            },
            clickOnlineStatus(value){
                this.$emit("update:onlineStatus", value)
                let form = {
                    code: this._category1
                };
                if(value > 0){
                    form['onlineStatus'] = value;
                }
                if (this._category2 !== ""){
                    form['code'] = this._category2;
                }
                this.$emit("getList", form);
            },
            getChildList(value){
                this.categoryChild = this.$store.getters.getCategoryChild(value);
                this.categoryChild.unshift({
                    "code": "",
                    "value": "全部"
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .type-navigation {
        /*padding: 0 24px;*/
        .type-title{
            position: relative;
            height: 60px;
            margin-bottom: 4px;
            div {
                position: absolute;
            }
            .content-style{
                height: 35px;
                width: 5px;
                background-color: #dd122a;
                top: 12.5px;
                left: 0;

            }
            .title-content{
                font-size: 20px;
                height: 40px;
                left: 15px;
                color: #333;
                line-height: 60px;
            }
        }
        color: #666;
        .type-card{
            padding: 10px 0 30px 0;
            .parent-col{
                margin-bottom: 30px;
                .parent-col-tab-container{
                    padding: 0 40px;
                    .parent-col-tabs{
                        border-bottom: 1px solid #e4e4e4;
                        .parent-col-tab{
                            font-size: 16px;
                            margin-right: 10px
                        }
                    }
                }
            }
        }
        .type-tag{
            position: relative;
            height: 40px;
            margin: 10px 0;
            p {
                position: absolute;
                height: 40px;
                line-height: 40px;
                width: 80px;
                text-align: justify;
            }
            p i{
                display:inline-block;
                width: 100%;
            }
            .content-box {
                width: 100%;
                position: absolute;
                height: 40px;
                line-height: 40px;
                /*left: 100px;*/
                ul::-webkit-scrollbar{
                    display: none;
                }
                ul {
                    width: 100%;
                    position: relative;
                    list-style: none;
                    white-space: nowrap;
                    overflow-x: auto;
                    li {
                        display:inline-block;
                        cursor: pointer;
                        /*float: left;*/
                        text-align: center;
                        margin: 0 20px;
                        height: 100%;
                        min-width: 80px;
                        padding: 0 15px;
                    }
                    li.active{
                        color: white;
                        background-color: #dd122a !important;
                        border-radius: 5px;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 540px) {
        .content-box {
            ul {
                width: 100%;
                height: 100%;
                li {
                    margin: 0 0.8rem !important;
                    padding: 0 0.8rem !important;
                }
            }
        }
    }
</style>
